import { useSelector } from 'react-redux';
import { useMemo } from 'react';

import { handleCommentary } from 'utils/handleCommentary';
import { convertCoinsToString } from 'utils/convertPrice';
import { BANK_MAX_SUM } from '../constants';
import * as helpers from '../../../helpers';

export const useDealItemPresenter = ({ deal, carInstance, application }) => {
  const itemParams = useSelector(
    (store) => store?.applications?.detailParams[application?.ids?.credit]
  );

  const apprData = deal?.AdditionalData?.approvData?.data[0] || {};
  const { comment: aprovComment, dealer_details = {}, bank_details = {} } = apprData;
  const statusComment = deal?.AdditionalData?.statusData?.comment || '';
  const bank_msg = deal?.AdditionalData?.statusData?.bank_msg || '';
  const bankId = Number(deal.bank.id);
  const bankName = deal.bank.name || '—';
  const state = deal.state.state;

  const { boldPrice, boldInitialMoney, boldPeriod, boldRate, boldDealerSum } = helpers.compareObj(
    itemParams,
    apprData
  );

  const dealParams = {
    carYearMax: deal.carYearMax || '—',
    monthly: helpers.convertValueToStandartNumber(apprData.monthly),
    bankDopSum: helpers.convertValueToStandartNumber(apprData.bank_dop_sum),
    dealerDopSum: helpers.convertValueToStandartNumber(apprData.dealer_dop_sum),
    rate: apprData.rate ? `${apprData.rate}%` : '—',
    term: apprData.term || '—',
    downPayment: helpers.convertValueToStandartNumber(apprData.down_payment),
    creditSum: helpers.convertValueToStandartNumber(apprData.credit_sum),
    maxLimit: `Максимальная сумма кредита ${
      apprData.max_limit ? convertCoinsToString(apprData.max_limit, false) : 'не определена'
    }`,
  };

  const checks = {
    isShowYear: helpers.isShowCarYear(carInstance, deal),
    bankMaxSum: BANK_MAX_SUM.includes(bankId),
    isAprove: helpers.checkApproveObj(apprData),
    statusCheck: helpers.checkStatus(state),
  };

  const commentary = {
    handleStatusComment: handleCommentary(statusComment).replaceAll('<br>', ' '),
    handleBankComment: handleCommentary(bank_msg).replaceAll('<br>', ' '),
    handleApproveComment: aprovComment
      ? handleCommentary(aprovComment).replaceAll('<br>', ' ')
      : '',
    bank_msg,
  };

  const boldItem = {
    boldDealerSum,
    boldInitialMoney,
    boldPeriod,
    boldPrice,
    boldRate,
    boldYear: deal.carYearMax > 0,
  };

  const hasLeasing = useMemo(() => {
    // 291, 862, 878 это id Совкомбанка
    const isCorrectBank = [291, 862, 878].includes(bankId);

    if (!isCorrectBank) {
      return false;
    }

    return [commentary.handleApproveComment, commentary.handleStatusComment].some(
      (comment) => comment && /лизинг/i.test(comment)
    );
  }, [commentary.handleApproveComment, commentary.handleStatusComment, bankId]);

  return {
    bank_details,
    bankId,
    bankName,
    boldItem,
    checks,
    commentary,
    dealer_details,
    dealParams,
    state,
    hasLeasing,
  };
};
